import React from 'react';
import { ExternalLink, Calendar } from 'lucide-react';
import "./News.css"
const NewsSection = () => {
  const newsItems = [
    {
      date: { day: '23', month: '' },
      category: 'Partnership'
    }
  ];

  return (
    <section className="news-section">
      <div className="container">
        <div className="section-header-news">
          <h2>Latest News</h2>
          <button className="see-all">View All Updates</button>
        </div>
        <div className="news-container">
          {newsItems.map((item, index) => (
            <div className="news-card" key={index}>
              <div className="news-card-header">
                <div className="news-date">
                  <span className="day">{item.date.day}</span>
                  <span className="month">{item.date.month}</span>
                </div>
                <span className="news-category">{item.category}</span>
              </div>
              {item.image && (
                <div className="news-image">
                  <img src={item.image} alt={item.title} />
                </div>
              )}
              <div className="news-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <div className="news-footer">
                  <a href={item.link} target="_blank" rel="noopener noreferrer" className="read-more">
                    Read More <ExternalLink size={16} />
                  </a>
                  <div className="news-meta">
                    <Calendar size={16} /> {item.date.day} {item.date.month}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
